
















































































































import Debounce from "debounce-decorator";
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";

@Component
export default class Step extends Vue {
  @Prop() private stepResult!: any;
  @Prop() private id!: number;
  @Prop() private taxCodes!: any;

  private stepData!: any;
  private chosenAnswers = {};
  private rangeAnswer: any = null;
  get widget() {
    return this.$store.state.widget;
  }
  restart() {
    (this.$parent as any).restart();
  }

  @Debounce(650)
  response(
    parameter: string,
    answer: any,
    r: any,
    id: number,
    event: any,
    displayName?: any
  ) {
    this.$set(this.chosenAnswers, parameter, answer);
    if (Object.keys(this.chosenAnswers).length == this.step.parameters.length) {
      (this.$parent as any).getNext(r, this.chosenAnswers, id, displayName);
    }
  }

  buttonOrDropdown(parameter: any) {
    if (parameter.possibleValues.length > 3) {
      return "dropdown";
    }

    if (
      parameter.possibleValues.map((x) => x.displayName).join(" ").length > 75
    ) {
      return "dropdown";
    }

    return "button";
  }

  get parameterNames() {
    return this.step.parameters.map((p: any) => p.parameterName).join(", ");
  }

  get step() {
    let type = "result";
    let name = this.stepResult.value;

    if (!name) {
      type = "question";
      name = this.stepResult.name;
      const question = this.stepResult.question;
      const parameters = this.stepResult.parameters.map((p: any) => {
        return {
          answerType: p.type,
          parameterName: p.name,
          possibleValues: p.metadata.possibleValues,
          range: p.metadata.range,
        };
      });
      const decisionId = this.stepResult.decisionId;

      this.stepData = {
        type,
        question,
        name,
        decisionId,
        parameters,
      };
    } else {
      this.stepData = { type, name };
    }
    return this.stepData;
  }
  onUseThis(step: any) {
    const taxcodeDetail = {
      code: step.name,
      desc: this.taxCodes[step.name],
      /* eslint-disable @typescript-eslint/camelcase */
      short_desc: this.taxCodes[step.name],
    };
    window.parent.postMessage(JSON.stringify(taxcodeDetail), "*");
  }

  private newTaxcodeText(date) {
    return (
      "New tax code! Code will be active from " +
      dayjs(date).format("D MMM, YYYY")
    );
  }

  private isNewTaxcode(date) {
    return dayjs(date).isAfter(dayjs(new Date()));
  }

  effectiveFrom(taxcode: string) {
    return this.$store.getters.taxcode(taxcode)?.effectiveFrom;
  }
}
